// TeamList.jsx
import React, { useContext, useEffect, useState } from "react";
import { useTeamData } from "../../actions/team/TeamContext";
import TeamItem from "./TeamItem";
import { AuthContext } from "../../context/AuthContext";
import axios from "axios";
import ENDPOINT from "../../context/EndPoint";
import Localbase from "localbase";
import { useActionsContext } from "../../context/ActionsContext";
import { useDispatch } from "react-redux";
import DefaultModal from "../../components/modals/DefaultModal";
import DefaultToast from "../../components/toasts/DefaultToast";
import SnackbarToast from "../../components/toasts/SnackbarToast";
import { Height, MoreVert } from "@material-ui/icons";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Dropdown, Accordion } from "react-bootstrap";
import { Pending } from "@mui/icons-material";
import { Check } from "react-bootstrap-icons";
import DeleteIcon from "@mui/icons-material/Delete";
import { set } from "firebase/database";


const TeamList = () => {
  const dispatch = useDispatch();

  const db = new Localbase("db");

  const { user } = useContext(AuthContext);
  const [departmentmodal, setDepartmentmodal] = useState(false);
  const [inputdepartment, setinputdepartment] = useState("");
  const [teamData, setTeamData] = useState("");
  const { rowsPerPage, setRowsPerPage } = useActionsContext();

  const [editdepartment, setEditDepartment] = useState({
    department: "",
    department_id: "",
  });

  const [show, setShow] = useState({
    open: false,
    message: "",
    type: "success",
  });
  const getDepartmentList = async () => {
    const data = new FormData();
    data.append("session", user.SessionId);
    data.append("limit", rowsPerPage);

    const response = await axios.post(
      ENDPOINT + "get-team-departments.php",
      data,
      {
        header: { "content-type": "multipart/form-data" },
      },
    );
    if (response) {
      if (response.data.status === "success") {
        setTeamData(response.data.data);
      }
    } else {
    }
  };


  const addDepartment = async (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append("session", user.SessionId);
    data.append("department", inputdepartment);

    try {
      const res = await axios.post(ENDPOINT + "add-team-department.php", data, {
        headers: {
          "content-type": "multipart/form-data",
        },
      });
      if (res) {
        console.log(res.data);
        if (res.data.status === "success") {
          setDepartmentmodal(false);
          getDepartmentList();
          setShow({
            open: true,
            message: "Department added successfully!",
            type: "success",
          });
        } else {
          setShow({
            open: true,
            message: res.data.message || "Failed to add department",
            type: "error",
          });
        }
      }
    } catch {}
  };

  const fetchTeamData = async (payload) => {
    const formData = new FormData();
    formData.append("session", user.SessionId);
    formData.append("department", payload);

    dispatch({ type: "LOADING" });
    try {
      const res = await axios.post(
        ENDPOINT + "get-internal-team-list.php",
        formData,
        {
          headers: {
            "content-type": "multipart/form-data",
          },
        },
      );
      if (res) {
        if (res.data.status === "success") {
          dispatch({ type: "DONE_LOADING" });
          var data = res.data.data;
          db.collection("paths").add({ data }, "internal_team");
        }
      } else {
        dispatch({ type: "error", payload: res.error.message });
      }

      if (res) {
        setInitialData(res.data.data);
        setResponse(res.data.data);
      } else {
        dispatch({ type: "error", payload: res.error.message });
      }
    } catch (error) {
      dispatch({ type: "error", payload: error.message });
    }
  };

  const deleteDepartment = async (payload) => {
    const data = new FormData();
    data.append("session", user.SessionId);
    data.append("department_id", payload);
    try {
      const res = await axios.post(ENDPOINT + "delete-department.php", data, {
        header: { "content-type": "multipart/formdata" },
      });
      if (res.data.status === "success") {
        getDepartmentList();
      }
    } catch (error) {}
  };

  const editDepartmentlist = async (e, payload) => {
    e.preventDefault();
    const data = new FormData();
    data.append("session", user.SessionId);
    data.append("department", editdepartment.department);
    data.append("department_id", editdepartment.department_id);
    try {
      const res = await axios.post(ENDPOINT + "edit-department.php", data, {
        header: { "content-type": "multipart/formdata" },
      });
      if (res.data.status === "success") {
        getDepartmentList();
        setEditModal(false);
        {
        }
      }
    } catch (err) {}
  };

  //offline func........
  const getOfflinedata = () => {
    db.collection("paths")
      .doc("internal_team")
      .get()
      .then((data) => {
        if (data) {
          setResponse(data.data);
        } else {
          fetchTeamData();
        }
      });
  };

  useEffect(() => {
    getDepartmentList();
    getOfflinedata();
  }, [rowsPerPage]);

  // Use teamData to render team list
  const [initialData, setInitialData] = useState("");
  const [response, setResponse] = useState(initialData);
  const [searchTerm, setSearchTerm] = useState("");
  const { searchquery } = useActionsContext();
  const [teamMembers, setTeamMembers] = useState([]);
  const [editModal, setEditModal] = useState(false);
  const [menudeletemodal, setdeleteMenuModal] = useState(false);
  const [expandedDept, setExpandedDept] = useState(null);


  const handleSearch = ({ term }) => {
    if (!term) {
      setResponse(initialData);
      setSearchTerm("");
      return;
    }
    if (term && initialData) {
      const filteredData = initialData.filter((item) => {
        return (
          item.first_name.toLowerCase().includes(term) ||
          item.last_name.toLowerCase().includes(term) ||
          item.joining_datetime.toLowerCase().includes(term) ||
          item.last_active_time.toLowerCase().includes(term)
        );
      });
      setResponse(filteredData);
      setSearchTerm(term);
    }
  };
  useEffect(() => {
    handleSearch({ term: searchquery });
  }, [searchquery]);

  return (
    <div>
      <DefaultModal
        show={editModal}
        HandleClose={() => setEditModal(false)}
        content={
          <>
            <div className="p-3">
              <form
                onSubmit={(e) =>
                  editDepartmentlist(e, editdepartment.department_id)
                }
              >
                <input
                  type="text"
                  className="form-control mb-3"
                  placeholder="Edit Department Name"
                  value={editdepartment.department}
                  onChange={(e) =>
                    setEditDepartment({
                      ...editdepartment,
                      department: e.target.value,
                    })
                  }
                />
                <div className="d-flex justify-content-end">
                  <button className="btn btn-primary px-4">Save Changes</button>
                </div>
              </form>
            </div>
          </>
        }
      />
 

      <div className="container-fluid">
        {/* Previous Search Filters */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="mb-0">Team Members</h4>
          <button
            onClick={() => setDepartmentmodal(true)}
            className="btn btn-primary"
          >
            <i className="ri-add-line me-1" />
            Add Department
          </button>
        </div>
        <div className="w-100">
          {teamData ? (
            <Accordion activeKey={expandedDept} className="w-100">
              {teamData.map((person) => (
                <Accordion.Item 
                  key={person.department_id} 
                  eventKey={person.department_id}
                  className="mb-3 rounded-4 border-3 border-primary"
                >
                  <Accordion.Header
                    onClick={() => {
                      setExpandedDept(
                        expandedDept === person.department_id 
                          ? null 
                          : person.department_id
                      );
                      fetchTeamData(person.department);
                    }}
                    className="text-center fw-bold py-4"
                    style={{
                      // backgroundColor: "#f8f9fa",
                      borderRadius: "12px",
                    }}
                  >
                    <h5 className="mb-0">{person.department}</h5>
                  </Accordion.Header>
                  <Accordion.Body className="p-4">
                    <div className="row g-3">
                      {response && response.length > 0 ? (
                        response.map((item, idx) => (
                          <div
                            key={item.id || idx}
                            className="col-12 col-sm-6 col-md-4 col-lg-3"
                          >
                            <TeamItem item={item} />
                          </div>
                        ))
                      ) : (
                        <div className="col-12 text-center text-muted py-5">
                          <i className="ri-user-search-line display-4 mb-2" />
                          <div>No team members found.</div>
                        </div>
                      )}
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          ) : (
            <div className="text-center py-5">
              <p>No departments available</p>
            </div>
          )}
        </div>
        <SnackbarToast
          open={show}
          handleClose={() =>
            setShow({ open: false, message: "", type: "success" })
          }
        />

        <DefaultModal
          show={departmentmodal}
          HandleClose={() => setDepartmentmodal(false)}
          content={
            <div className="p-3">
              <h5 className="mb-3">Add Department</h5>
              <form onSubmit={addDepartment}>
                <input
                  className="form-control mb-3"
                  type="text"
                  placeholder="Department name"
                  value={inputdepartment}
                  onChange={(e) => setinputdepartment(e.target.value)}
                />
                <div className="d-flex justify-content-end">
                  <button className="btn btn-primary px-4">Submit</button>
                </div>
              </form>
            </div>
          }
        />

        {/* end col */}
      </div>

      {/* end row */}

      {/* end row */}
    </div>
  );
};

export default TeamList;
